import { CoreSelections } from '../../@types';
import { SyncState } from '@sonar-software/xuder';

export type CoreSelectionsState = SyncState<CoreSelections>;

export const defaultSelectionState: CoreSelectionsState = { data: {} };
